export default __webpack_public_path__ + "static/media/checkmark-outline.17f01c4a.svg";